import React, { useContext, useEffect } from 'react'
import { PageHeader } from '../../Components/Headers'
import { VotingDescription } from './VotingDescription'
import { HrInline } from '../../Components/Headers/HrInline'
import { VoteBackground, RootVoteCon, VoteHeadSection } from './styles'
import { AllStarOuter } from './components/AllStarOuter'
import { AllStarContext } from '../../Context'
import { useAuthContext } from '../../Context/AuthContext/AuthContext'
import { GeneralSlideUp } from '../../Components/Layout/Slideups/GeneralSlideUp'
import { SLIDEUP_HEIGHTS, colors } from '../../Components/consts'
import { GenLoginForm } from '../../Components/Auth/GenLoginForm'
import { ALL_STAR_VOTE_BANNER, ALL_STAR_IMAGES, ANALYTICS_TAGS, ALL_STAR_TICKET_LINK } from '../../Constant'

const AllStarVote: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { isLoggedIn, authLoading } = useAuthContext()
  const { showLoginPrompt, toggleLoginPrompt } = useContext(AllStarContext)!

  useEffect(() => {
    if (!authLoading && !isLoggedIn) {
      toggleLoginPrompt()
    }
  }, [authLoading, isLoggedIn])

  const ticketButtonAnalytics = {
    event: ANALYTICS_TAGS.ticket_click,
    params: {
      ticketType: 'day',
      status: 'live',
      section: 'all_star_voting',
      ticketUrl: ALL_STAR_TICKET_LINK,
    },
  }

  const handleLoginPromptClose = () => {
    toggleLoginPrompt()
  }

  return (
    <>
      <VoteBackground></VoteBackground>
      <RootVoteCon>
        <VoteHeadSection>
          <PageHeader
            banner={ALL_STAR_VOTE_BANNER}
            img={ALL_STAR_VOTE_BANNER!.topUrl}
            link={ALL_STAR_VOTE_BANNER?.topLink}
          />
          <HrInline
            title={`Lexus All-Star Voting`}
            subtitle={`2025 Lexus All-Star Weekend • July 4th - 5th • Kansas City, MO`}
            imgUrl={ALL_STAR_IMAGES.votingLogo}
            buttonText={`Tickets`}
            buttonLink={ALL_STAR_TICKET_LINK}
            analytics={ticketButtonAnalytics}
            uiTheme="dark"
          />
          <VotingDescription />
        </VoteHeadSection>
        <AllStarOuter />
        {!isLoggedIn && showLoginPrompt && (
          <GeneralSlideUp
            height={SLIDEUP_HEIGHTS.third}
            visible={showLoginPrompt}
            showClose
            handleClose={handleLoginPromptClose}
            bgColor={colors.darkBackground}
          >
            <GenLoginForm
              theme={'dark'}
              title={'Log in for PLL Nation credit'}
              desc={`PLL Nation members have more influence based on status. Log in to get credit towards your achievements.`}
            />
          </GeneralSlideUp>
        )}
      </RootVoteCon>
    </>
  )
}

export default AllStarVote
